import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/user-group-1.webp")